import { useFlags } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";
import { ApplicationFlowState } from "src/apps/AppFlow/screens/root/Layout";
import { AgreementParagraph } from "src/components";
import { selectApplicationLocation } from "src/selectors";
import { createStyles } from "src/styles";

import { isTruthy } from "@fraction/shared";

import { ImportantTermsAndInfo, ImportantTermsAndInfoNoPdfView, SubmissionReview } from "./pages";

const styles = createStyles({
  agreement: {
    marginBottom: 20,
  },
});

const USA_PROP_OVERRIDES = {
  buttonText: "View important terms and information",
  overflowTextFallback: "Next",
  doFullSubmit: false,
};

const useSubmissionReviewPages = ({
  state,
  onBack,
  onNext,
}: {
  state: ApplicationFlowState;
  onNext: () => void;
  onBack: () => void;
}) => {
  const { isUSA } = selectApplicationLocation(state.propertyLocation);
  const { pdfBookletNoPreview } = useFlags();

  return useMemo(
    () =>
      [
        {
          name: "Review",
          component: (
            <SubmissionReview
              blockFocus="start"
              value={state}
              onBack={onBack}
              onNext={onNext}
              {...(isUSA && USA_PROP_OVERRIDES)}
            >
              {!isUSA && <AgreementParagraph style={styles.agreement} />}
            </SubmissionReview>
          ),
        },
        isUSA && !pdfBookletNoPreview
          ? {
              name: "importantTermsAndInfo",
              component: (
                <ImportantTermsAndInfo
                  location={state.propertyLocation}
                  blockFocus="start"
                  value={state}
                  onBack={onBack}
                  onNext={onNext}
                  termLength={state.term?.length}
                />
              ),
            }
          : null,
        isUSA && pdfBookletNoPreview
          ? {
              name: "importantTermsAndInfo",
              component: (
                <ImportantTermsAndInfoNoPdfView
                  location={state.propertyLocation}
                  blockFocus="start"
                  value={state}
                  onBack={onBack}
                  onNext={onNext}
                />
              ),
            }
          : null,
      ].filter(isTruthy),
    [state, onBack, onNext, pdfBookletNoPreview, isUSA]
  );
};

export default useSubmissionReviewPages;
